export default __webpack_public_path__ + "static/media/aae1f74536dd9a934122312de48275ba.svg";